import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import type { StyleValue } from '@vue/runtime-dom';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import CheckIconSvg from '@/components/partials/war-room/WarRoomPostPollV2/WarRoomPostPollV2Results/images/check.vue.svg';
import type { IPostPoll, IPostPollChoice } from '@/types/community';

type WarRoomPostPollResultsChoiceProps = {
  poll: IPostPoll;
  choice: IPostPollChoice;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostPollResultsChoice',
  props: {
    poll: null,
    choice: null
  },
  setup(__props: any) {

const props = __props as {
  poll: IPostPoll;
  choice: IPostPollChoice;
};



const width = ref('');
const item = ref<HTMLElement | null>(null);
let timeoutId: number;

const percentage = computed(() => {
  // here it should be all the time
  const pollVotesCount = props.poll.votes_count;
  return pollVotesCount ? props.choice.votes_count && Math.round((props.choice.votes_count / pollVotesCount) * 100) : 0;
});

const opacity = computed(() => Math.min(1, (percentage.value / 100) * 0.7 + 0.3));
const fillStyle = computed<StyleValue>(() => ({
  width: width.value,
  opacity: `${opacity.value}`,
}));

function calculateWidth() {
  if (props.choice.current_vote && item.value) {
    // we need this bc width width check icon is different
    const { clientWidth } = item.value;
    let pxWidth = ((clientWidth + 13) * percentage.value) / 100 - 13;

    // sometimes progress less than check ison. so we set minimum 5px width for progress line
    if (pxWidth <= 0) {
      pxWidth = 5;
    }

    width.value = `${(pxWidth / clientWidth) * 100}%`;
  } else {
    width.value = `${percentage.value}%`;
  }
}

onMounted(() => {
  calculateWidth();
  // on mobile there is chance that layout will change width after loading, so we need calculate again
  timeoutId = window.setTimeout(calculateWidth, 1000);
});

onUnmounted(() => {
  window.clearTimeout(timeoutId);
});

return { __sfc: true,props, width, item, timeoutId, percentage, opacity, fillStyle, calculateWidth, BravadoText, CheckIconSvg }
}

})